import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import All from "./all";
import PendingCustomers from "./pending";
import Audiences from "./audiences";
import AudienceDetail from "./audiences/detail";
import CustomerMap from "./map";

const PARENT_URL = "/cms/customers";

const Customers = () => {
  return (
    <Routes>
      <Route path={`/all`} element={<All />} />
      <Route path={`/pending`} element={<PendingCustomers />} />
      <Route path={`/map`} element={<CustomerMap />} />
      <Route path={`/audiences`} element={<Audiences />} />
      <Route path={`/audiences/:id`} element={<AudienceDetail />} />
      <Route path={``} element={<Navigate to={`${PARENT_URL}/customers`} replace />} />
    </Routes>
  );
};

export default Customers;
